// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__1tZkF","ranges":"BmiRanges_ranges__1sPmV"};